import { useQuery } from "react-query";
import { getActiveEmployees } from "../../../../../actions/Employees";
import { useRecoilValue } from "recoil";
import { accountAtom } from "modules/Login/atoms/AccountAtom";

const useGetActiveEmployees = () => {
  const user = useRecoilValue(accountAtom);

  return useQuery("GetActiveEmployees", getActiveEmployees, {
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.filter((x) => {
        if (user.isMexico && !user.isFranchise && !user.isConfie) {
          return x.isMexico === true;
        }

        if (!user.isMexico && (user.isFranchise || user.isConfie)) {
          return x.isMexico === false;
        }

        return true;
      });
    },
  });
};

export default useGetActiveEmployees;
